// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.message {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #18cb96, #13b587);
  color: #ffffff;
  padding: 14px 28px;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 500;
  font-family: 'HeroLight', sans-serif;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  opacity: 0;
  animation: slideFade 2.2s ease-in-out forwards;
  z-index: 1000;
}

@keyframes slideFade {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(20px);
  }
  10% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  90% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
  }
}

.formSection {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    width: 100%;
}

.form {
    background: #ffffff;
    padding: 32px;
    margin: 40px auto;
    max-width: 520px;
    border-radius: 16px;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-family: 'Poppins', sans-serif;
    animation: fadeIn 0.3s ease-in-out;
    width: 80%;
}

@keyframes fadeIn {
  from {
    transform: translateY(12px);
    opacity: 0;
  }
  to {
    transform: translateY(0px);
    opacity: 1;
  }
}

.formHead h2 {
  font-family: "HeroLight", sans-serif;
  text-align: center;
  color: #373643;
  margin-bottom: 0px;
  font-size: 32px;
  font-weight: 600;
}

.formInput {
  background-color: #f8f9fa;
  color: #373643;
  border: 1px solid #d3d3d3;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 1rem;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}

.formInput:focus {
  border-color: #18cb96;
  box-shadow: 0 0 0 3px rgba(24, 203, 150, 0.2);
  outline: none;
}

textarea.formInput {
  resize: vertical;
  min-height: 100px;
}

button[type="submit"] {
  background: linear-gradient(135deg, #18cb96, #13b587);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 14px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

button[type="submit"]:hover {
  background: linear-gradient(135deg, #13b587, #0fa175);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(19, 181, 135, 0.4);
}

select.formInput option {
  background-color: #ffffff;
  color: #373643;
}
`, "",{"version":3,"sources":["webpack://./src/form/form.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,qDAAqD;EACrD,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,UAAU;EACV,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;EACA;IACE,UAAU;IACV,6CAA6C;EAC/C;AACF;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kCAAkC;IAClC,kCAAkC;IAClC,UAAU;AACd;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,UAAU;EACZ;AACF;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["\r\n.message {\r\n  position: fixed;\r\n  bottom: 30px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: linear-gradient(135deg, #18cb96, #13b587);\r\n  color: #ffffff;\r\n  padding: 14px 28px;\r\n  border-radius: 14px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  font-family: 'HeroLight', sans-serif;\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);\r\n  opacity: 0;\r\n  animation: slideFade 2.2s ease-in-out forwards;\r\n  z-index: 1000;\r\n}\r\n\r\n@keyframes slideFade {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateX(-50%) translateY(20px);\r\n  }\r\n  10% {\r\n    opacity: 1;\r\n    transform: translateX(-50%) translateY(0);\r\n  }\r\n  90% {\r\n    opacity: 1;\r\n    transform: translateX(-50%) translateY(0);\r\n  }\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateX(-50%) translateY(-10px);\r\n  }\r\n}\r\n\r\n.formSection {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 100vh;\r\n    width: 100%;\r\n}\r\n\r\n.form {\r\n    background: #ffffff;\r\n    padding: 32px;\r\n    margin: 40px auto;\r\n    max-width: 520px;\r\n    border-radius: 16px;\r\n    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n    font-family: 'Poppins', sans-serif;\r\n    animation: fadeIn 0.3s ease-in-out;\r\n    width: 80%;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    transform: translateY(12px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0px);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.formHead h2 {\r\n  font-family: \"HeroLight\", sans-serif;\r\n  text-align: center;\r\n  color: #373643;\r\n  margin-bottom: 0px;\r\n  font-size: 32px;\r\n  font-weight: 600;\r\n}\r\n\r\n.formInput {\r\n  background-color: #f8f9fa;\r\n  color: #373643;\r\n  border: 1px solid #d3d3d3;\r\n  border-radius: 10px;\r\n  padding: 12px 16px;\r\n  font-size: 1rem;\r\n  transition: border 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.formInput:focus {\r\n  border-color: #18cb96;\r\n  box-shadow: 0 0 0 3px rgba(24, 203, 150, 0.2);\r\n  outline: none;\r\n}\r\n\r\ntextarea.formInput {\r\n  resize: vertical;\r\n  min-height: 100px;\r\n}\r\n\r\nbutton[type=\"submit\"] {\r\n  background: linear-gradient(135deg, #18cb96, #13b587);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\nbutton[type=\"submit\"]:hover {\r\n  background: linear-gradient(135deg, #13b587, #0fa175);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(19, 181, 135, 0.4);\r\n}\r\n\r\nselect.formInput option {\r\n  background-color: #ffffff;\r\n  color: #373643;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
